export default {
  CRA: {
    type: {
      staging: '//localhost:8000',
      development: '//localhost:3000/signin',
      dev: '//dev.gatsby.wisedoc.net/signin',
      prerelease: '//cra.wisedoc.net/signin',
      production: '//docs.wisedoc.net/signin',
    },
  },
  GATSBY: {
    type: {
      staging: '//localhost:3000',
      development: '//localhost:3000',
      dev: 'https://dev.cra.wisedoc.net',
      prerelease: 'https://cra.wisedoc.net',
      production: 'https://docs.wisedoc.net',
    },
  },
};
